import { Button } from '../catalyst/button';
import { Input, InputGroup } from '../catalyst/input';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/16/solid';

export default function SearchInput({ value, onChange, onCancelSearch, placeholder = 'Search' }) {
  return (
    <InputGroup>
      <Input
        name="search"
        className="min-w-72"
        placeholder={`${placeholder}...`}
        aria-label="Search"
        value={value}
        onChange={onChange}
        onKeyUp={(e) => {
          if (e.key === 'Escape') {
            onCancelSearch();
          }
        }}
      />

      {value && value.trim() ? (
        <div className="absolute right-0 top-0">
          <Button
            plain
            onClick={onCancelSearch}
          >
            <XMarkIcon />
          </Button>
        </div>
      ) : (
        <MagnifyingGlassIcon />
      )}
    </InputGroup>
  );
}
